<template>
    <div class="extra-number">
        <div class="row head">
            <div class="col col-100">Extra nummer aanvragen</div>
        </div>

        <div class="row setting">
            <div  v-if="$root.app.platform == 'android'" class="col col-100" v-bind:class="{ 'validation-error': $v.extraPostcode.$error }">
                <span class="row__title">Postcode</span><br/>
                <input v-model="extraPostcode" type="text" placeholder="1200AA" @input="$v.extraPostcode.$touch()"/>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__title">Postcode</span>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50" v-bind:class="{ 'validation-error': $v.extraPostcode.$error }">
                <input v-model="extraPostcode" type="text" placeholder="1111AA" @input="$v.extraPostcode.$touch()"/>
            </div>

        </div>

        <div class="row setting">
            <div  v-if="$root.app.platform == 'android'" class="col col-100" v-bind:class="{ 'validation-error': $v.extraHousenumber.$error }">
                <span class="row__title">Huisnummer</span><br/>
                <input v-model="extraHousenumber" type="text" placeholder="1 A" @input="$v.extraHousenumber.$touch()"/>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__title">Huisnummer</span>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50" v-bind:class="{ 'validation-error': $v.extraHousenumber.$error }">
                <input v-model="extraHousenumber" type="text" placeholder="1 A" @input="$v.extraHousenumber.$touch()"/>
            </div>
        </div>

        <div class="row setting">
            <div  v-if="$root.app.platform == 'android'" class="col col-100" v-bind:class="{ 'validation-error': $v.extraNumberName.$error }">
                <span class="row__title">Naam</span><br/>
                <input v-model="extraNumberName" type="text" placeholder="Dubline" @input="$v.extraNumberName.$touch()"/>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__title">Naam</span>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50" v-bind:class="{ 'validation-error': $v.extraNumberName.$error }">
                <input v-model="extraNumberName" type="text" placeholder="Dubline" @input="$v.extraNumberName.$touch()"/>
                
            </div>
        </div>


        <!-- <div class="row setting" v-bind:class="{'setting--nb': $root.app.platform == 'android'}">
            <div v-if="$root.app.platform == 'android'" class="col col-100">
                <span class="row__title">Aantal extra nummers</span><br/>
                <div class="select-wrap">
                    <select v-model="extraNumbersSelected" name="categories">
                        <option v-for="extraNumberOption in extraNumberOptions" :value="extraNumberOption.value" :key="extraNumberOption.id">
                            {{ extraNumberOption.text }}
                        </option>
                    </select>
                    <span class="select-arrow"></span>
                </div>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <span class="row__title">Aantal extra nummers</span>
            </div>
            <div v-if="$root.app.platform == 'ios'" class="col col-50">
                <select v-model="extraNumbersSelected" name="categories">
                    <option v-for="extraNumberOption in extraNumberOptions" :value="extraNumberOption.value" :key="extraNumberOption.id">
                        {{ extraNumberOption.text }}
                    </option>
                </select>
            </div>
        </div> -->

        <div class="info col">
            <span v-if="this.$route.params.numberType =='local'">
                Na aanvraag wordt een nummer aangemaakt in de regio van de bovenstaande postcode. Dit kan maximaal 2 werkdagen duren. De naam van het nummer ziet u in beeld als u gebeld wordt op dit nummer.
            </span>

            <span v-else>
                Na aanvraag wordt een 085-nummer aangemaakt. Dit kan maximaal 2 werkdagen duren. De naam van het nummer ziet u in beeld als u gebeld wordt op dit nummer.
            </span>
        </div>

        <div class="row row-button row-button--bottom">
            <div class="col col-100">
                <input type="hidden" name="extraNumberSubject" value="Aanvraag lokaal nummer" v-if="this.$route.params.numberType =='local'" />
                <input type="hidden" name="extraNumberSubject" value="Aanvraag 085 nummer" v-else />
                <button @click="requestExtraNumber()" class="button">Aanvragen</button>
            </div>
        </div>
    </div>
</template>

<script>
import { required, minLength, email} from 'vuelidate/lib/validators';

const zipcode = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^[1-9][0-9]{3}[\s]?[A-Za-z]{2}$/i.test(value)
}

export default {
    data() {
        return {
            extraPostcode: '',
            extraHousenumber: '',
            extraNumberName: '',
            extraNumberSubject: 'Aanvraag extra nummer',
            // extraNumbersSelected: "1",
            // extraNumberOptions: [
            //     {text: '1', value: '1'},
            //     {text: '2', value: '2'},
            //     {text: '3', value: '3'},
            //     {text: '4', value: '4'},
            // ],
            message: '',

        }
    },

    validations: {
        extraPostcode: {
            required,
            zipcode
        },
        extraHousenumber: {
            required,
        },
        extraNumberName: {
            required,
        }
    },

    methods: {
        requestExtraNumber() {
            if(this.$v.$invalid) {
                this.$root.ui.showDialog(
                    'Fout',
                    'De ingevulde informatie is niet correct<br/>',
                    true
                );
                return;
            }
            var _this = this;

            this.$root.ui.showDialog(
                'Extra nummer',
                'Er wordt nu een aanvraag ingediend voor een extra nummer. Hier zijn kosten aan verbonden.'
                + '<br><br> Ga je akkoord met:'
                + '<br> Extra nummer'
                + '<br> €1.00 per maand excl. btw'
                + '<br> maandelijks opzegbaar',
                false,
                {
                    0:{
                        name: 'Ik ga akkoord',
                        execute: function(){
                            let bundleMessage =  `
                                Extra nummer aanvraag: <br>
                                postcode: ${_this.extraPostcode} <br>
                                huisnummer: ${_this.extraHousenumber}<br>
                                naam: ${_this.extraNumberName}<br>
                                nummertype: ${_this.$route.params.numberType}

                                `;
                            _this.message = bundleMessage;
                            _this.$root.app.state = 'get';
                            _this.$root.loading = true;
                            
                            _this.$api.post('/tickets', {
                                type: 4,
                                category: 2,
                                subject: _this.extraNumberSubject,
                                message: bundleMessage
                            })
                            .then(response => {
                                _this.$root.loading = false;

                                _this.$root.ui.showDialog(
                                    'Voltooid',
                                    'De extra nummer/nummers zijn aangevraagd!',
                                    true
                                );
                                _this.$router.go(-1); //Back to bundels
                            })
                            .catch(e => {
                                console.log(e.response.data.message.message);
                                _this.$root.loading = false;
                                _this.$root.ui.showDialog(
                                    'Fout',
                                    e.response.data.message.message,
                                    true
                            )
                            });
                        }
                    },
                    1:{
                        name: 'Annuleren',
                        execute: function(){}
                    }
                }
            );
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/bundles/ExtraNumberRequest.vue